import React from "react";
import "./HouseingTransform.css";

const CorporatePestControlTransform = () => {
  return (
    <section className="workplace-cta-section">
      <div className="workplace-cta-container">
        <h2 className="workplace-cta-title">
          Protect Your Facility from Pests
        </h2>

        <p className="workplace-cta-text">
          Get professional pest control services to maintain a clean, healthy,
          and pest-free environment
        </p>

        <a
          href="https://wa.me/919899811123?text=Corporate%20Pest%20Control"
          target="_blank"
          rel="noopener noreferrer"
          className="workplace-cta-btn"
        >
          Book a Pest Control →
        </a>
      </div>
    </section>
  );
};

export default CorporatePestControlTransform;
